import * as moment from 'moment';

import { IEventFilter } from './classes';

/**
 * Go to the next month. If necessary, will load data.
 */
export function nextMonth() {
    return {
        type: ActionType.NextMonth
    }
}

/**
 * Go to the last month. If necessary, will load data.
 */
export function previousMonth() {
    return {
        type: ActionType.PreviousMonth
    }
}

export function setDates(startDate: moment.Moment, endDate: moment.Moment) {
    return {
        type: ActionType.SetDates,
        value: { startDate, endDate }
    }
}

export function setCourseTypeFilter(courseType: string) {
    return {
        type: ActionType.ApplyCourseTypeFilter,
        value: courseType
    }
}

export function setEventTypeFilter(eventType: string) {
    return {
        type: ActionType.ApplyEventTypeFilter,
        value: eventType
    }
}

export function setInstructorFilter(instructor: string) {
    return {
        type: ActionType.ApplyInstructorFilter,
        value: instructor
    }
}

export function setFormatFilter(format: string) {
    return {
        type: ActionType.ApplyFormatFilter,
        value: format
    }
}

export function setLocationFilter(location: string) {
    return {
        type: ActionType.ApplyLocationFilter,
        value: location
    }
}

export function togglePriceFilter() {
    return {
        type: ActionType.TogglePriceFilter
    }
}
export function resetFilters() {
    return {
        type: ActionType.ResetFilters
    }
}

export function setMonthFilter(month: string) {
    return {
        type: ActionType.ApplyMonthFilter,
        value: month
    }
}

export function getNextEvents(currentOffset: number) {
    return {
        type: ActionType.GetNextEvents,
        value: currentOffset
    }
}

export function getPreviousEvents(currentOffset: number) {
    return {
        type: ActionType.GetPreviousEvents,
        value: currentOffset
    }
}

export class ActionType {
    static get NextMonth() {
        return "NextMonth";
    }
    static get PreviousMonth() {
        return "PreviousMonth";
    }

    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    static get EventUpdated() {
        return "EventUpdated";
    }
    static get SetDates() {
        return "SetDates";
    }

    static get UpdateEvents() {
        return "UpdateEvents";
    }

    static get ApplyCourseTypeFilter() {
        return "ApplyCourseTypeFilter";
    }

    static get ApplyEventTypeFilter() {
        return "ApplyEventTypeFilter";
    }

    static get ApplyInstructorFilter() {
        return "ApplyInstructorFilter";
    }

    static get ApplyFormatFilter() {
        return "ApplyFormatFilter";
    }

    static get TogglePriceFilter() {
        return "TogglePriceFilter";
    }

    static get GetNextEvents() {
        return "GetNextEvents";
    }

    static get GetPreviousEvents() {
        return "GetPreviousEvents";
    }

    static get ResetFilters() {
        return "ResetFilters";
    }

    static get ApplyMonthFilter() {
        return "ApplyMonthFilter";
    }

    static get ApplyLocationFilter() {
        return "ApplyLocationFilter";
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/actions.ts